export default "__VITE_ASSET__a2a1a4c2__"